import classNames from "classnames";
import { AccordionList, Container, Heading3 } from "shared/components";

import styles from "./Content055.module.scss";

export const Content055 = ({ payload }) => {
  const title = payload?.title ?? "";
  const template = payload?.template ?? "light";
  const points = payload?.faq ?? [];

  return (
    <div className={classNames(styles.wrapper, styles[template])}>
      <Container className={styles.inner}>
        <div className={styles.blocks}>
          <Heading3 as="h3" className={styles.title}>
            {title}
          </Heading3>
          <div className={styles.content}>
            <AccordionList
              items={points}
              className={styles.list}
              appearance="bold"
              togglePlus
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Content055;
